var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSearch = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(77)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-63.176,12.976l-4.2-4.2a.6.6,0,0,0-.074-.05A4.173,4.173,0,0,0-66.6,6.2,4.2,4.2,0,0,0-70.8,2,4.2,4.2,0,0,0-75,6.2a4.2,4.2,0,0,0,4.2,4.2,4.173,4.173,0,0,0,2.526-.85.6.6,0,0,0,.05.074l4.2,4.2A.6.6,0,0,0-63.6,14a.6.6,0,0,0,.424-.176A.6.6,0,0,0-63.176,12.976ZM-70.8,9.2a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1-70.8,9.2Z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-search.ab1ea83c.svg";
export { ForwardRef as ReactComponent };